import * as React from 'react';

import HeaderButton from 'bundles/unified-description-page-common/components/accordions/HeaderButton';

export type AccordionHeaderElement = React.ReactElement<Props, typeof AccordionHeader>;

export type Props = {
  children?: React.ReactNode | React.ReactNode[];
  toggleButtonLabel: string;
  labelProps?: Record<string, string>;
};

const AccordionHeader = React.forwardRef(function AccordionHeader(props: Props, ref: React.Ref<HTMLHeadingElement>) {
  const { children, toggleButtonLabel } = props;

  return (
    <div ref={ref}>
      <HeaderButton label={toggleButtonLabel}>{children}</HeaderButton>
    </div>
  );
});

export default AccordionHeader;
